module.exports = __webpack_public_path__ + "img/offical1.b9013725.jpg";